import classNames from 'classnames';

export function ChartTooltipArrow({ side }) {
  const base = 'pointer-events-none absolute h-0 w-0 border-5 border-transparent';
  const style = {};
  let cls = base;

  if (side === 'top') {
    cls = classNames(base, 'border-t-woodsmoke-500/90');
    Object.assign(style, {
      left: '50%',
      bottom: 0,
      transform: 'translate(-50%, 100%)',
    });
  } else if (side === 'bottom') {
    cls = classNames(base, 'border-b-woodsmoke-500/90');
    Object.assign(style, {
      left: '50%',
      top: 0,
      transform: 'translate(-50%, -100%)',
    });
  } else if (side === 'left') {
    cls = classNames(base, 'border-l-woodsmoke-500/90');
    Object.assign(style, {
      right: 0,
      top: '50%',
      transform: 'translate(100%, -50%)',
    });
  } else if (side === 'right') {
    cls = classNames(base, 'border-r-woodsmoke-500/90');
    Object.assign(style, {
      left: 0,
      top: '50%',
      transform: 'translate(-100%, -50%)',
    });
  }

  if (!style.transform) return null;

  return <div className={cls} style={style} />;
}
